import ConfirmIcon from '@mui/icons-material/Check';
import PropTypes from 'prop-types';
import React, {
  useCallback,
  useMemo,
  useState,
} from 'react';

import CardText from 'components/Card/Text';
import CardTitle from 'components/Card/Title';
import auth from 'lib/auth';

import PrimaryButton from './PrimaryButton';
import TermsOfService from './TermsOfService';

const TermsOutOfDate = ({ loading, onLoading, onStateChange }) => {
  const [error, setError] = useState(null);
  return (
    <>
      <CardTitle title='Terms of Service Updated' />
      <CardText noTopPadding>
        Our Terms of Service have updated since you last signed in.
        Please agree to the updated terms to continue.
      </CardText>
      <TermsOfService />
      <CardText noTopPadding>
        <PrimaryButton
          disabled={loading}
          error={error}
          icon={useMemo(
            () => <ConfirmIcon />,
            [],
          )}
          label='Agree to Terms of Service'
          onClick={useCallback(
            async () => {
              onLoading(true);
              const { err, message, state } = await auth.agreeToTerms();
              if (err) {
                setError(message);
                onLoading(false);
              } else if (state) {
                onStateChange(state);
              } else {
                onLoading(false);
              }
            },
            [
              onLoading,
              onStateChange,
            ],
          )}
        />
      </CardText>
    </>
  );
};

TermsOutOfDate.propTypes = {
  loading: PropTypes.bool,
  onLoading: PropTypes.func.isRequired,
  onStateChange: PropTypes.func.isRequired,
};

export default TermsOutOfDate;
